'use client';
var classes = {"root":"m-d46a4834","inner":"m-b85f7144","fullScreen":"m-96f6e9ad","dropzone":"m-7946116d"};

export { classes as default };
//# sourceMappingURL=Dropzone.module.css.mjs.map
